import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { Constants } from '../../../../core/services/constants';
import 'rxjs/add/operator/finally';
import { LoginService } from '../login.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ErrorDialogComponent } from '../../error-dialog/error-dialog.component';
import { GeneralService } from '../../../services/general.service';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss']
})
export class ForgotComponent implements OnInit {
  forgotForm: FormGroup;
  forgotSubmit: Boolean = false;
  statusMessage: String;
  forgotError: Boolean = false;
  forgotWrongUserError: Boolean = false;
  processComplete: Boolean = false;
  loading: Boolean = false;

  fileNameDialogRef: MatDialogRef<ErrorDialogComponent>;

  constructor(private router: Router,
    private loginService: LoginService,
    private dialog: MatDialog,
    private generalService: GeneralService) { }

  openDialog(errorMessage: string): void {
    this.fileNameDialogRef = this.dialog.open(ErrorDialogComponent, {
      data: {
        errorMsg: errorMessage
      },
      autoFocus: false,
      panelClass: 'errorPopup'
    });
  }

  ngOnInit() {
    this.forgotForm = new FormGroup({
      user: new FormControl('', Validators.nullValidator && Validators.required),
    });
  }

  onForgot(form: NgForm) {
    this.loading = true;
    this.loginService.sendRecoveryEmail(form.value.user)
      .finally(() => {
        this.loading = false;
        this.forgotSubmit = true;
      })
      .subscribe(
        res => {
          this.router.navigate(['/new-password'], { queryParams: { username: form.value.user } });
          // this.statusMessage = Constants.FORGOT_EMAIL_SENT;
          // this.forgotError = false;
          // this.forgotWrongUserError = false;
          // this.processComplete = true;
        },
        err => {
          if (err.message === Constants.MSG.USER_NOT_FOUND) {
            this.forgotWrongUserError = true;
            this.statusMessage = err.message;
          } else {
            this.forgotWrongUserError = false;
            this.openDialog(err.message);
          }
          this.forgotError = true;
        }
      );
  }

  cleanForm() {
    if (this.forgotError) {
      this.forgotError = false;
      this.forgotWrongUserError = false;
      this.forgotSubmit = false;
      this.statusMessage = '';
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/login/forgot/forgot.component.ts